import WarehouseManagementModule from "@/modules/WarehouseManagement";

function WarehouseManagementPage() {
  return <WarehouseManagementModule />;
}

export default WarehouseManagementPage;
